import localStore from 'store'
import cacheKeys from '@/store/cacheKeys'
import { getPermissionCode } from '@/api/auth'

const state = {
  fullNavCodes: {}, // 完整的导航权限
  fullPageCodes: {}, // 完整的页面权限
  version: '', // 当前权限版本
  roles: [], // 当前用户角色信息
  currentNavCodes: [], // 当前用户导航权限
  currentPageCodes: [] // 当前用户页面权限
}

const mutations = {
  INIT_CODES: (state, { data, roles }) => {
    state.fullNavCodes = data.nav
    state.fullPageCodes = data.page
    state.version = data.version
    state.roles = roles
    const currentNavCodes = []
    for (const nav in data.nav) {
      // eslint-disable-next-line no-prototype-builtins
      if (!data.nav.hasOwnProperty(nav)) {
        continue
      }
      const currentRoles = data.nav[nav]
      const intersect = roles.filter(v => {
        return currentRoles.indexOf(v) > -1
      })
      if (intersect.length > 0) {
        currentNavCodes.push(nav)
      }
    }
    state.currentNavCodes = currentNavCodes

    const currentPageCodes = []
    for (const page in data.page) {
      // eslint-disable-next-line no-prototype-builtins
      if (!data.page.hasOwnProperty(page)) {
        continue
      }
      const currentRoles = data.page[page]
      const intersect = roles.filter(v => {
        return currentRoles.indexOf(v) > -1
      })
      if (intersect.length > 0) {
        currentPageCodes.push(page)
      }
    }
    state.currentPageCodes = currentPageCodes
  }
}

const actions = {
  initCodes({ commit, dispatch }, { version, roles }) {
    // 读取本地的
    const fullData = localStore.get(cacheKeys.FULL_PERMISSION_INFO_MAP)

    // 最终的数据提交操作
    const retData = (data, form) => {
      console.log(`读取权限数据从: ${form}, 版本: ${data.version}`)
      commit('INIT_CODES', { data, roles })
      return new Promise(resolve => {
        resolve({
          roles: state.roles,
          routePermission: state.currentNavCodes
        })
      })
    }

    // 处理一个新的操作
    // eslint-disable-next-line space-before-function-paren
    const retNew = async () => {
      const fullData = await getPermissionCode()
      localStore.set(cacheKeys.FULL_PERMISSION_INFO_MAP, fullData.data.data)
      return retData(fullData.data.data, 'Network')
    }

    if (
      typeof fullData !== 'object' ||
      // eslint-disable-next-line no-prototype-builtins
      !fullData.hasOwnProperty('version') ||
      fullData.version !== version
    ) {
      return retNew()
    }
    // 返回旧的
    return retData(fullData, 'localStore')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
